module.exports = __webpack_public_path__ + "img/half_cut_cell_dual.b7018a34.png";